import { NextPage } from "next";
import { LandingPageBlocks } from "~/components/LandingPage/LandingPageBlocks";
import { PostEditCTA, PostEditCTAProps } from "~/components/PostEditCTA";
import { LandingPageBlock } from "./schemas";

export interface LandingPageProps {
  blocks: LandingPageBlock[];
  preview: boolean;
  postEditCTAProps: PostEditCTAProps;
}

export const LandingPage: NextPage<LandingPageProps> = ({
  blocks,
  preview,
  postEditCTAProps,
}): JSX.Element => (
  <>
    <PostEditCTA {...postEditCTAProps} />
    <div className="relative mx-auto grid max-w-6xl grid-cols-1 gap-16 p-4 py-16 sm:py-6 md:px-6 lg:gap-xxl lg:p-8">
      <LandingPageBlocks blocks={blocks} preview={preview} />
    </div>
  </>
);
